import React from "react";
import { Container } from "react-bootstrap";

function Help() {
    return (
        <Container className="empty-height">
            <h1>Welcome to Help Page</h1>
        </Container>
    );
}

export default Help;
